<template>
    <div>
        <maincontent>
            <template v-slot:header>
                <h1>{{ $t('pages.cio_as_a_service.title') }}</h1>
                <p>{{ $t('pages.cio_as_a_service.subtitle') }}</p>
            </template>

            <template v-slot:col1>
                <span
                    class="subtitle"
                >{{ $t('pages.cio_as_a_service.sections.temporary_cio.title') }}</span>
                <p>{{ $t('pages.cio_as_a_service.sections.temporary_cio.body') }}</p>

                <span class="subtitle">{{ $t('pages.cio_as_a_service.sections.mkb.title') }}</span>
                <p>{{ $t('pages.cio_as_a_service.sections.mkb.body') }}</p>
            </template>
            <template v-slot:col2>
                <span class="subtitle">{{ $t('pages.cio_as_a_service.sections.services.title') }}</span>
                <p>{{ $t('pages.cio_as_a_service.sections.services.body') }}</p>

                <ul v-if="$i18n.messages[$i18n.locale]">
                    <li
                        v-for="(item, index) in $i18n.messages[$i18n.locale].pages.cio_as_a_service.sections.services.list_items"
                        :key="index"
                    >{{ item }}</li>
                </ul>
            </template>
            <template v-slot:remark>
                <p class="remark" v-html="$t('pages.cio_as_a_service.sections.services.lead')"></p>
            </template>
        </maincontent>

        <fullimage
            :img="require('@/assets/images/hand-with-smartwatch-holding-smartphone.jpg')"
            inverse
        >
            <p v-html="$t('pages.cio_as_a_service.lead')"></p>
        </fullimage>

        <navigationgrid :showing="[true,true,false,true,true]"></navigationgrid>
    </div>
</template>

<script>
import homehero from "@/components/homehero.vue";
import fullimage from "@/components/fullimage.vue";
import navigationgrid from "@/components/navigationgrid.vue";
import navigationcard from "@/components/navigationcard.vue";
import wwdfooter from "@/components/wwdfooter.vue";
import maincontent from "@/components/maincontent.vue";

export default {
    components: {
        homehero: homehero,
        fullimage: fullimage,
        navigationgrid: navigationgrid,
        navigationcard: navigationcard,
        wwdfooter: wwdfooter,
        maincontent: maincontent
    }
};
</script>
